function getBadge(state) {
  let opts = {
    ERROR: "danger",
    WARNING: "info",
    OK: "success",
    TRIGGERED: "warning",
    //Sheriff Status
    INITIALIZING: "warning",
    DISCONNECTED: "danger"
  };
  return `badge badge-pill badge-${opts[state]} mb-1`;
}
function getSensorName(sensorDescription) {
  let opts = {
    MisalignmentSensor: "Sensor de alinhamento",
    ObstructionSensor: "Sensor de embuxamento",
    MovementSensor: "Sensor de movimento",
    TemperatureSensor: "Sensor de temperatura"
  };
  return opts[sensorDescription];
}
function filterSensorsByType(sheriff, sensorType, showDisabled) {
  let sensors = sheriff ? sheriff.sensors : [];
  return sensors.filter(
    sensor =>
      sensor.sensorDescription == sensorType &&
      (sensor.sensorConfiguration.enabled || showDisabled)
  );
}
function filterSensorsByState(sheriff, sensorState) {
  let sensors = sheriff ? sheriff.sensors : [];
  return sensors.filter(
    sensor => sensor.state == sensorState && sensor.sensorConfiguration.enabled
  );
}
export { getBadge, getSensorName, filterSensorsByState, filterSensorsByType };
